import React from 'react';
import clsx from 'clsx';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import { CalendarState, calendarStates, toggleValue } from './calendarFilterModel';
import { calendarStateFilterMessages } from './calendarMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the Calendar; each part uses its own slice of it */
import styles from './PromoteCalendar.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface StateFilterChipsProps {
  counts: Record<CalendarState, number>;
  selected: CalendarState[];
  onChange: (states: CalendarState[]) => void;
}

/**
 * The state chips with their counts (design a1). With no pick every state but Canceled shows; a
 * pick shows only the picked states, Canceled too.
 */
const StateFilterChipsComponent: React.FC<StateFilterChipsProps> = ({ counts, selected, onChange }) => {
  const intl = useIntl();
  return (
    <div
      className={styles.stfilter}
      role="group"
      aria-label={intl.formatMessage({ id: 'app.sml.promote.calendar.filter.states', defaultMessage: 'State' })}
    >
      {calendarStates.map((state) => (
        <button
          key={state}
          type="button"
          className={clsx(
            styles.stchip,
            state === 'needsYou' && counts.needsYou > 0 && styles.stchipNeed,
            state === 'failed' && counts.failed > 0 && styles.stchipBad,
            selected.includes(state) && styles.stchipOn
          )}
          aria-pressed={selected.includes(state)}
          data-testid={`state-chip-${state}`}
          onClick={() => onChange(toggleValue(selected, state))}
        >
          {intl.formatMessage(calendarStateFilterMessages[state])}
          <b>{counts[state]}</b>
        </button>
      ))}
    </div>
  );
};

export const StateFilterChips = TypedMemo(StateFilterChipsComponent);
